import { Component, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'ff-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {

  /**
   * Message to display in the snackbar
   * @internal
   */
  @Input() message: string = '';

  /**
   * Action text to display.
   * @internal
   */
  @Input() action: string = '';

  /**
   * Text to display in the button
   * @internal
   */
  @Input() buttonText: string = '';

  constructor(private _snackBar: MatSnackBar) { }

  openSnackBar = (): void => {
    this._snackBar.open(this.message, this.action);
  }
}
